import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Fallback, falls die API (noch) nicht antwortet. Massgeblich sind die DB-Preise (/api/pricing).
export const DEFAULT_PRICING = {
  currency: "CHF",
  license: { einzel: 590, team: 2900 },
  ai_extension: {
    einzel: { 30: 59, 90: 149, 365: 490 },
    team: { 30: 290, 90: 690, 365: 1900 },
  },
};

let _cache = null;
let _promise = null;

// Nach Preisänderungen im Admin aufrufen, damit neue Werte in derselben Session sofort greifen.
export function clearPricingCache() {
  _cache = null;
  _promise = null;
}

export function formatCHF(amount) {
  const n = Number(amount) || 0;
  const isInt = Number.isInteger(n);
  const s = n.toLocaleString("de-CH", {
    minimumFractionDigits: isInt ? 0 : 2,
    maximumFractionDigits: 2,
  });
  return isInt ? `CHF ${s}.–` : `CHF ${s}`;
}

// Laedt die Preise einmal pro Seitenaufruf (Modul-Cache) und teilt sie ueber alle Komponenten.
export function usePricing() {
  const [pricing, setPricing] = useState(_cache || DEFAULT_PRICING);
  useEffect(() => {
    let alive = true;
    if (_cache) {
      setPricing(_cache);
      return;
    }
    if (!_promise) {
      _promise = api
        .get("/pricing")
        .then((r) => {
          _cache = r.data;
          return r.data;
        })
        .catch(() => DEFAULT_PRICING);
    }
    _promise.then((p) => {
      if (alive) setPricing(p);
    });
    return () => {
      alive = false;
    };
  }, []);
  return pricing;
}

export function aiExtensions(pricing, plan) {
  const key = plan === "team" ? "team" : "einzel";
  const map = (pricing && pricing.ai_extension && pricing.ai_extension[key]) || DEFAULT_PRICING.ai_extension[key];
  return Object.keys(map)
    .map((d) => Number(d))
    .sort((a, b) => a - b)
    .map((days) => ({ days, amount: map[days], price: formatCHF(map[days]), note: "exkl. MWST" }));
}

export function licensePrice(pricing, plan) {
  const key = plan === "team" ? "team" : "einzel";
  const amount = (pricing && pricing.license && pricing.license[key]) ?? DEFAULT_PRICING.license[key];
  return { amount, price: formatCHF(amount), note: "exkl. MWST" };
}
